<p-dialog
  [(visible)]="visivel"
  (onHide)="fechado.emit()"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '960px', maxWidth: '96vw' }"
  [breakpoints]="{ '960px': '96vw' }"
  styleClass="dialog-wave-redesign importar-pedido-dialog">

  <!-- HEADER WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-file-import" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.importar_pedido.titulo' | translate }}</h2>
        <p>{{ 'vendas.importar_pedido.subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">

    <!-- Filtro por tipo de servico -->
    <div class="ip-tipos">
      <button *ngFor="let opcao of opcoesTipoServico"
        type="button"
        class="ip-chip"
        [class.ip-chip-ativo]="tipoSelecionado === opcao.valor"
        (click)="selecionarTipo(opcao.valor)">
        {{ opcao.rotulo }}
      </button>
    </div>

    <!-- Busca + estado -->
    <div class="ip-filtros">
      <span class="p-input-icon-left ip-busca">
        <i class="pi pi-search"></i>
        <input pInputText type="text" class="w-full"
          pAutoFocus [autofocus]="true"
          [(ngModel)]="busca"
          (input)="onBuscaChange()"
          [placeholder]="'vendas.importar_pedido.buscar_ph' | translate" />
      </span>

      <p-dropdown
        [options]="opcoesEstado"
        [(ngModel)]="estadoSelecionado"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        panelStyleClass="dropdown-panel-above-modal"
        styleClass="ip-estado"
        (onChange)="onEstadoChange()">
      </p-dropdown>
    </div>

    <!-- Lista de pedidos -->
    <p-table
      [value]="pedidos"
      [lazy]="true"
      [loading]="carregando"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      selectionMode="single"
      [(selection)]="pedidoSelecionado"
      (onRowSelect)="selecionar($event.data)"
      dataKey="id"
      styleClass="p-datatable-sm p-datatable-striped">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 12%">{{ 'vendas.importar_pedido.col_pedido' | translate }}</th>
          <th style="width: 26%">{{ 'vendas.importar_pedido.col_cliente' | translate }}</th>
          <th style="width: 22%">{{ 'vendas.importar_pedido.col_servico' | translate }}</th>
          <th style="width: 18%">{{ 'vendas.importar_pedido.col_estado' | translate }}</th>
          <th style="width: 22%" class="text-right">{{ 'vendas.importar_pedido.col_pendente' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-pedido>
        <tr [pSelectableRow]="pedido"
            [class.ip-linha-selecionada]="pedidoSelecionado?.id === pedido.id"
            (dblclick)="selecionar(pedido); importar()">
          <td class="font-semibold">#{{ pedido.codigoDePedido }}</td>
          <td>{{ pedido.nomeCliente || '-' }}</td>
          <td>
            <span class="ip-servico">
              <i [class]="iconeTipoServico(pedido)"></i>
              {{ rotuloTipoServico(pedido) }}
            </span>
            <div *ngIf="identificacaoDeMesa(pedido)" class="ip-mesa">
              {{ identificacaoDeMesa(pedido) }}
            </div>
          </td>
          <td>
            <span class="ip-estado-tag" [style.background]="corEstado(pedido)">
              {{ rotuloEstado(pedido) }}
            </span>
          </td>
          <td class="text-right">
            <span class="font-semibold">{{ pedido.valorPendente | number: '1.0-2' }}</span>
            <!--
              O pedido faturado em parte continua na lista, porque ainda sobra saldo; a marca
              evita que o operador estranhe o valor menor que o total do pedido.
            -->
            <div *ngIf="ehFaturadoParcial(pedido)" class="ip-parcial">
              {{ 'pedidos.labels.faturado_parcial' | translate }}
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center p-4 text-500">
            {{ 'vendas.importar_pedido.vazio' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="ip-paginacao">
      <p-paginator
        (onPageChange)="onPageChange($any($event))"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'vendas.importar_pedido.contagem' | translate"
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [showFirstLastIcon]="true">
      </p-paginator>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ 'vendas.importar_pedido.itens_por_pagina' | translate }}</span>
        <p-dropdown
          [options]="opcoesLinhasPorPagina"
          [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()"
          styleClass="w-6rem"
          appendTo="body"
          panelStyleClass="dropdown-panel-above-modal">
        </p-dropdown>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      [label]="('vendas.importar_pedido.cancelar' | translate) + ' (Esc)'"
      (click)="fechar()">
    </button>
    <button pButton icon="pi pi-check"
      [label]="('vendas.importar_pedido.confirmar' | translate) + ' (Enter)'"
      [disabled]="!pedidoSelecionado || importando"
      [loading]="importando"
      (click)="importar()">
    </button>
  </ng-template>
</p-dialog>
